// Import custom components
import "./components/index.ts";

// Import modules
import { getInitialLang, switchLang, updateEmailButton } from "./utils/lang.ts";
import { initChecklistAutomation } from "./pages/checklist.ts";
import {
  initAIAssessment,
  initFileUpload,
  initFormDraftPersistence,
} from "./pages/assessment.ts";
import { initGetAdvice } from "./pages/advice.ts";
import { initPDFDownload } from "./utils/download.ts";
import { initKinde, isAuthenticated, login, logout } from "./utils/auth.ts";
import { DISCOVERY_URL } from "./utils/urls.ts";
import { applyBrandContent, applyBrandTheme } from "./utils/brand.ts";

// Apply the domain-specific theme as early as possible to avoid a flash of
// the default theme on non-default domains.
applyBrandTheme();

document.addEventListener("DOMContentLoaded", async function () {
  // Rewrite brand references (title, metas, visible text) for the active domain
  applyBrandContent();

  // Initialize Kinde auth first (handles post-login redirect before anything else)
  await initKinde();

  // Update auth buttons based on current auth state
  await updateAuthButtons();

  // Initialize language
  const initialLang = getInitialLang();
  switchLang(initialLang);

  // Initialize email button on page load
  updateEmailButton(initialLang);

  // Add click listeners to language buttons
  document.querySelectorAll(".lang-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const button = btn as HTMLElement;
      const lang = button.dataset.lang;
      if (lang) {
        switchLang(lang);
      }
    });
  });

  // Navbar Scroll Effect
  addEventListener("scroll", () => {
    const nav = document.getElementById("navbar");
    if (nav) {
      if (scrollY > 50) {
        nav.classList.add("shadow-md", "py-2");
        nav.classList.remove("py-4");
      } else {
        nav.classList.remove("shadow-md", "py-2");
        nav.classList.add("py-4");
      }
    }
  });

  // Set href on all discovery links from the central constant
  document.querySelectorAll<HTMLAnchorElement>("[data-discovery-link]").forEach(
    (a) => {
      a.href = DISCOVERY_URL;
    },
  );

  // Checklist automation
  initChecklistAutomation();

  // Restore any saved form draft (must run after initChecklistAutomation so
  // section-checkbox listeners are already in place)
  initFormDraftPersistence();

  // Get Advice button (mailto)
  initGetAdvice();

  // PDF Download button
  initPDFDownload();

  // File upload drop zone
  initFileUpload();

  // AI Assessment button
  initAIAssessment();

  // set all the necessary functions in the globalThis scope
  globalThis.switchLang = switchLang;
  globalThis.getInitialLang = getInitialLang;
  globalThis.updateEmailButton = updateEmailButton;
});

/** Show/hide and wire up the Login/Logout button(s) rendered by dammi-header. */
async function updateAuthButtons(): Promise<void> {
  const authed = await isAuthenticated();

  for (const btnId of ["kinde-auth-btn", "kinde-auth-btn-mobile"]) {
    const btn = document.getElementById(btnId);
    if (!btn) continue;

    // Only show the button when Kinde is configured
    btn.classList.remove("hidden");

    const loginSpan = btn.querySelector<HTMLElement>(".kinde-login-text");
    const logoutSpan = btn.querySelector<HTMLElement>(".kinde-logout-text");

    if (authed) {
      loginSpan?.classList.add("hidden");
      logoutSpan?.classList.remove("hidden");
      btn.onclick = () => logout();
    } else {
      loginSpan?.classList.remove("hidden");
      logoutSpan?.classList.add("hidden");
      btn.onclick = () => login();
    }
  }
}
